import React, { useState } from 'react';
import { FileImage, ExternalLink } from 'lucide-react';
import { muted } from './mbApi';

const driveId = (u) => u.match(/drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?(?:.*&)?id=)([\w-]+)/)?.[1];
const ytId = (u) => u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/)?.[1];

// Pratonton dimuat oleh browser sahaja (tiada fetch backend); fail private tetap private — fallback dipaparkan.
export const thumbOf = (u) => {
  if (!u || !u.startsWith('https://')) return null;
  if (/\.(png|jpe?g|webp|gif)(\?|$)/i.test(u)) return u;
  const d = driveId(u);
  if (d) return `https://drive.google.com/thumbnail?id=${d}&sz=w400`;
  const y = ytId(u);
  if (y) return `https://img.youtube.com/vi/${y}/mqdefault.jpg`;
  return /(drive|docs)\.google\.com|youtube\.com|youtu\.be/.test(u) ? null : u;
};

export const AssetPreview = ({ c, small = false }) => {
  const [failed, setFailed] = useState(false);
  const src = thumbOf(c.asset_link);
  const box = small ? 'w-16 h-12' : 'w-full sm:w-40 h-28';
  return (
    <div className={`${box} shrink-0 rounded-md overflow-hidden border border-[hsl(var(--border))] bg-white/[0.03] flex items-center justify-center`} data-testid={`mb-asset-preview-${c.id}`}>
      {src && !failed ? (
        <img src={src} alt={`Pratonton ${c.version_label}`} loading="lazy" referrerPolicy="no-referrer" className="w-full h-full object-cover" onError={() => setFailed(true)} />
      ) : (
        <span className={`text-xs ${muted} flex flex-col items-center gap-1 px-1 text-center`}>
          <FileImage size={small ? 16 : 22} />
          {!small && (c.asset_link ? 'Pratonton tak tersedia' : 'Tiada link bahan')}
        </span>
      )}
    </div>
  );
};

export const OpenAsset = ({ c }) => (c.asset_link ? (
  <a href={c.asset_link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm underline text-[hsl(var(--primary))] min-h-10" data-testid={`mb-creative-asset-${c.id}`}>
    Buka bahan <ExternalLink size={14} />
  </a>
) : null);
